export default "__VITE_ASSET__BH_GMiS6__"